import React, { Component } from "react";
import { Row, Card, CardBody } from "reactstrap";
import Chart from "react-google-charts";
import { connect } from "react-redux";
import Axios from "axios";
import { withStyles } from "@material-ui/core/styles";

import ContentWrapper from "../../template/Layout/ContentWrapper";
import VectorMap from "./components/Maps/VectorMap";
import CardsTotals from "./components/CardTotals";
import { Autocomplete, TextField } from "@mui/material";

import { FullLoader } from "./components/Loader";
import { TableLoader as ShipmentMap } from "./components/Loader";
import Loader from "../../Global/Loader";
import { Services } from "../../../repositories/clients/Services";
import "./styles.scss";
import paises from "./components/Maps/paises.json";
import EventsTable from "./components/EventsTable";

import {
  FOURTH_COLOR,
  PRIMARY_COLOR,
  DARK_GREY_BLUE,
  DARKER_GREY_BLUE,
} from "../../../utils/colors";

import { withNamespaces } from "react-i18next";

/**
 * @markerColor : the marker points
 * @bgColor : the background
 * @scaleColors : the color of the region in the serie
 * @regionFill : the base region color
 */

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000",
  },
  oblDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000",
    },
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});

const defaultColors = {
  markerColor: "#737373",
  // markerColor:"#BBBEC6",
  bgColor: "transparent",

  scaleColors: ["#737373"],
  // scaleColors: ["#BBBEC6"],

  regionFill: "#BBBEC6",
};

/*=============================================
=            Dashboard Component Functions    =
=============================================*/
// const latitudPaises = [
//   { latLng: [22.480076, -102.528762], name: 'MX', code: "MX" },
//   { latLng: [40.125132, -103.096824], name: 'USA', code: "USA" },
//   { latLng: [46.595109, 2.870231], name: 'FRA', code: "FRA" }

// ];
/*=============================================
=            Dashboard Component              =
=============================================*/
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleShipmentForCountry: "",
      MapShipmentCountry: <></>,
      shipmentForCountrySelected: 1,
      userId: props._user,
      language: props.lng,
      optionShipmentForCountry: [
        { label: props.t("origin"), text: props.t("origin"), value: 1 },
        {
          label: props.t("destination"),
          text: props.t("destination"),
          value: 2,
        },
      ],

      optionShipmentDefault: {
        label: props.t("origin"),
        text: props.t("origin"),
        value: 1,
      },
      optionShipmentTrendYear: [
        {
          label: new Date().getFullYear(),
          text: props.t("origin"),
          value: new Date().getFullYear(),
        },
        {
          label: new Date().getFullYear() - 1,
          text: props.t("destination"),
          value: new Date().getFullYear() - 1,
        },
      ],

      optionShipmentTrendDefafault: {
        label: new Date().getFullYear(),
        text: props.t("origin"),
        value: new Date().getFullYear(),
      },
      shipmentTrendYear: new Date().getFullYear(),
      text: "",
      ModoTransporte: {},
      colors: [DARK_GREY_BLUE, PRIMARY_COLOR, FOURTH_COLOR, DARKER_GREY_BLUE],
      isMovil: false,
      totales: {
        EmbarquesMaritimos: 0,
        EmbarquesAereos: 0,
        Contenedores: 0,
        EmbarquesTerrestres: 0,
      },
      flat: false,
      tendenciaData: [],
      eventosAtencion: [],
      maxTendencia: 0,
      tendenciaOptions: {
        series: {
          lines: {
            show: false,
          },
          points: {
            show: true,
            radius: 4,
          },
          splines: {
            show: true,
            tension: 0.4,
            lineWidth: 1,
            fill: 0.5,
          },
        },
        grid: {
          borderColor: "#eee",
          borderWidth: 1,
          hoverable: true,
          backgroundColor: "#fcfcfc",
        },
        tooltip: true,
        tooltipOpts: {
          content: (label, x, y) => x + " : " + y,
        },
        xaxis: {
          tickColor: "#fcfcfc",
          mode: "categories",
        },
        yaxis: {
          min: 0,
          tickColor: "#eee",
          autoscaleMargin: 0.5,
          tickDecimals: 0,
          tickFormatter: (v) => v,
        },
        shadowSize: 0,
      },
      Attention: [],
      estatusEmbarques: [],
      Map: [],
      loadingTrends: true,
      loadingTrendYear: true,
      loadingTotals: true,
      loadingShiptmenMap: true,
      RegionValues: {},
      fullLoader: false,
      markers: [],
      markersValue: [],
    };
  }
  /*=============================================
  =            Get Info Dashboard Function      =
  =============================================*/
  getInfoDashBoard = async () => {
    let {
      totales,
      estatusEmbarques,
      markersValue,
      RegionValues,
      shipmentTrendYear,
      shipmentForCountrySelected,
      language,
      eventosAtencion,
    } = this.state;
    //############ INVOCACION COMENTADA ##############
    let data = {
      shipmentForCountrySelected: shipmentForCountrySelected,
      language: language,
      shipmentTrendYear,
      Entities:
        this.props.clients.length > 0
          ? JSON.stringify(this.props.clients)
          : "[0]",
      userId: this.props._user,
      lang: this.props.lng,
    };
    let response = await Axios.post(
      `${Services.DASHBOARD.path}dashboard/total`,
      data,
    );

    if (response.status === 200) {
      totales = this.obtieneTotales(response.data.data);
      estatusEmbarques = this.obtieneEstatusEmbarques(response.data.data);
      await this.obtieneTendenciasEmbarques(response.data.data.Tendencia);
      eventosAtencion = response.data.data.EventosAtencion;
      markersValue = response.data.data.regionValues;
      RegionValues = this.obtieneRegionValues(response.data.data.regionValues);
    }

    let NewMap = (
      <VectorMap
        options={{
          map: "world_mill_en",
          markersSelectable: true,
          backgroundColor: defaultColors.bgColor,
          zoomMin: 1,
          zoomMax: 8,
          zoomOnScroll: false,
          regionStyle: {
            initial: {
              fill: defaultColors.regionFill,
              "fill-opacity": 1,
              stroke: "none",
              "stroke-width": 1.5,
              "stroke-opacity": 1,
            },
            hover: {
              //fill: '#020E3A',
              fillOpacity: 0.8,
            },
            selected: {
              fill: "#085fb0",
            },
            selectedHover: {
              fill: "#085fb0",
              fillOpacity: 0.8,
            },
          },
          focusOn: {
            x: 0.4,
            y: 0.6,
            scale: 1,
          },
          markerStyle: {
            initial: {
              fill: defaultColors.markerColor,
              fillOpacity: 1,
            },
          },
          onRegionLabelShow: (e, el, code) => {
            paises.countries.forEach((pais) => {
              if (pais.code === code) {
                el.html(this.props.lng === "EN" ? pais.name_en : pais.name_es);
              }
            });
            markersValue.forEach((mark) => {
              if (mark.PaisId === code) {
                el.html(
                  el.html() +
                    ": " +
                    mark.total +
                    " " +
                    this.props.t("shipments"),
                );
              }
            });
          },
          // onRegionOver: (e, code) => {
          //   e.preventDefault();
          // },
          // // onMarkerSelected: this.handleMarkerClick,
          // onMarkerLabelShow: (e, el, code) => {
          //   e.preventDefault();
          // },
        }}
        series={{
          regions: [
            {
              values: RegionValues,
              scale: defaultColors.scaleColors,
              normalizeFunction: "polynomial",
            },
          ],
        }}
        // markers={markers}
        markers={[]}
      />
    );

    this.setState({
      ModoTransporte: response.data.data.ModoTransporte,
      // titleShipmentForCountry: response.data.data.titleShipmentForCountry,
      titleShipmentForCountry: this.props.t("shipment_origin_country"),
      estatusEmbarques,
      eventosAtencion,
      totales,
      loadingTotals: false,
      loadingTrends: false,
      loadingShiptmenMap: false,
      fullLoader: true,
      MapShipmentCountry: NewMap,
      // markers,
      // markersValue,
      // RegionValues,
    });
  };

  obtieneRegionValues = (regionValues) => {
    var arrayValues = [];
    regionValues.forEach((region) => {
      arrayValues[region.PaisId] = Number(region.total);
    });
    return arrayValues;
  };

  obtieneValorMarkers = (regionValues) => {
    var codeValues = [];
    var keys = [];
    regionValues.forEach((element) => {
      if (codeValues.length === 0 || keys.indexOf(element.POD) < 0) {
        codeValues.push({ total: 1, code: element.POD });
        keys.push(element.POD);
      } else {
        var index = codeValues.findIndex((code) => code.code === element.POD);

        codeValues[index].total = codeValues[index].total + 1;
      }
    });

    return codeValues;
  };

  obtieneMarkers = (markersVaues, markers) => {
    var orderedMarker = [];
    markersVaues.forEach((element) => {
      var mark = markers.filter((marker) => marker.name === element.name);
      orderedMarker.push(mark ? mark[0] : null);
    });
    return orderedMarker;
  };

  handleChangeDrop = (attribute) => (evt, data) => {
    let { shipmentForCountrySelected, shipmentTrendYear } = this.state;
    let value = data.value;
    if (attribute === "shipmentForCountry") {
      shipmentForCountrySelected = value;
    } else if (attribute === "shipmentTrend") {
      shipmentTrendYear = value;
    }

    this.setState(
      {
        shipmentForCountrySelected,
        shipmentTrendYear,
      },
      () => {
        if (attribute === "shipmentForCountry") {
          this.getDataMapShipments();
        } else if (attribute === "shipmentTrend") {
          this.getDataTrendShipments();
        }
      },
    );
  };

  getDataTrendShipments = async () => {
    this.setState({ loadingTrendYear: true }, async () => {
      let { shipmentTrendYear, language } = this.state;
      let data = {
        shipmentTrendYear,
        language,
        Entities:
          this.props.clients.length > 0
            ? JSON.stringify(this.props.clients)
            : "[0]",
        userId: this.props._user,
        lang: this.props.lng,
      };
      let response = await Axios.post(
        `${Services.DASHBOARD.path}dashboard/shipmentTrend`,
        data,
      );

      if (response.status === 200) {
        await this.obtieneTendenciasEmbarques(response.data.data.Tendencia);
      }
    });
  };

  getDataMapShipments = async () => {
    this.setState(
      {
        loadingShiptmenMap: true,
      },
      async () => {
        try {
          let {
            markersValue,
            RegionValues,
            userId,
            shipmentForCountrySelected,
            language,
          } = this.state;

          let data = {
            shipmentForCountrySelected: shipmentForCountrySelected,
            userId: Number(userId),
            language: language,
            Entities:
              this.props.clients.length > 0
                ? JSON.stringify(this.props.clients)
                : "[0]",
          };

          let response = await Axios.post(
            `${Services.DASHBOARD.path}dashboard/getMapData`,
            data,
          );
          if (response.status === 200) {
            markersValue = response.data.data.regionValues;
            RegionValues = this.obtieneRegionValues(
              response.data.data.regionValues,
            );
          }
          let NewMap = (
            <VectorMap
              options={{
                map: "world_mill_en",
                markersSelectable: true,
                backgroundColor: defaultColors.bgColor,
                zoomMin: 1,
                zoomMax: 8,
                zoomOnScroll: false,
                regionStyle: {
                  initial: {
                    fill: defaultColors.regionFill,
                    "fill-opacity": 1,
                    stroke: "none",
                    "stroke-width": 1.5,
                    "stroke-opacity": 1,
                  },
                  hover: {
                    //fill: '#020E3A',
                    fillOpacity: 0.8,
                  },
                  selected: {
                    fill: "#085fb0",
                  },
                  selectedHover: {
                    fill: "#085fb0",
                    fillOpacity: 0.8,
                  },
                },
                focusOn: {
                  x: 0.4,
                  y: 0.6,
                  scale: 1,
                },
                markerStyle: {
                  initial: {
                    fill: defaultColors.markerColor,
                    fillOpacity: 1,
                  },
                },
                onRegionLabelShow: (e, el, code) => {
                  paises.countries.forEach((pais) => {
                    if (pais.code === code) {
                      el.html(
                        this.props.lng === "US" ? pais.name_en : pais.name_es,
                      );
                    }
                  });
                  markersValue.forEach((mark) => {
                    if (mark.PaisId === code) {
                      el.html(
                        el.html() +
                          ": " +
                          mark.total +
                          " " +
                          this.props.t("shipments"),
                      );
                    }
                  });
                },
              }}
              series={{
                regions: [
                  {
                    values: RegionValues,
                    scale: defaultColors.scaleColors,
                    normalizeFunction: "polynomial",
                  },
                ],
              }}
              // markers={markers}
              markers={[]}
            />
          );
          this.setState({
            loadingShiptmenMap: false,
            MapShipmentCountry: NewMap,
            titleShipmentForCountry: response.data.data.titleShipmentForCountry,
          });
        } catch (error) {
          console.log("error", error);
        }
      },
    );
  };

  obtieneEventosAtencion = async (EventosAtencion) => {
    // const allowUsers = ["1", "3", "4"];
    // let data = {
    //   Entities: this.props.clients ? JSON.stringify(this.props.clients) : '[0]'
    // };
    //############ INVOCACION COMENTADA ##############
    // let getAttention =
    // allowUsers.includes(this.props._rolId) ?
    //  await Axios.post(`${Services.DASHBOARD.path}dashboard/events`, data)
    // : '';
    let Attention = EventosAtencion;
    // allowUsers.includes(this.props._rolId) ?
    // getAttention.data.data
    //  : [];
    this.setState({ Attention });
  };

  obtieneTendenciasEmbarques = async (data) => {
    console.log(
      "🚀 ~ file: index.js:571 ~ Home ~ obtieneTendenciasEmbarques= ~ data:",
      data,
    );
    let { tendenciaData, maxTendencia } = this.state;
    tendenciaData = [["x", this.props.t("shipments")]];
    data[0].data.forEach((mes) => {
      tendenciaData.push([mes[0], parseInt(mes[1])]);
      if (parseInt(mes[1]) > maxTendencia) {
        maxTendencia = mes.total;
      }
    });
    console.log("tendenciaData-->", tendenciaData);
    this.setState({ tendenciaData, maxTendencia, loadingTrendYear: false });
  };

  obtieneEstatusEmbarques = (data) => {
    var estatus = [];
    var colorInicial = "#0060a8";
    data.Embarques.forEach((value) => {
      // if (value.estatus !== 'Creado' && value.estatus !== 'En tránsito a destino') {
      estatus.push({
        nombre: value.estatus,
        total: parseInt(value.total),
        color: colorInicial,
        extra: "",
      });
      colorInicial = this.colores(colorInicial);
      // }
    });
    let Logistics = [
      [
        "Element",
        "Total",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    try {
      estatus.forEach((value) => {
        const element = value;
        Logistics.push([
          element.nombre,
          element.total,
          element.color,
          element.extra,
        ]);
      });
      return Logistics;
    } catch (error) {
      return Logistics;
    }
  };

  hex = (c) => {
    var s = "0123456789abcdef";
    var i = parseInt(c);
    if (i === 0 || isNaN(c)) return "00";
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
  };
  convertToHex = (rgb) => {
    return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
  };
  trim = (s) => {
    return s.charAt(0) === "#" ? s.substring(1, 7) : s;
  };

  convertToRGB = (hex) => {
    var color = [];
    color[0] = parseInt(this.trim(hex).substring(0, 2), 16);
    color[1] = parseInt(this.trim(hex).substring(2, 4), 16);
    color[2] = parseInt(this.trim(hex).substring(4, 6), 16);
    return color;
  };
  colores = (startHex) => {
    var start =
      this.convertToRGB(startHex); /* The beginning of your gradient */
    var end = this.convertToRGB("#FFFFFF"); /* The end of your gradient */

    var alpha = 0.7; /* Alpha blending amount */
    var c = [];

    // for (var i = 0; i < len; i++) {

    c[0] = start[0] * alpha + (1 - alpha) * end[0];
    c[1] = start[1] * alpha + (1 - alpha) * end[1];
    c[2] =
      start[2] * alpha +
      (1 - alpha) * end[2]; /* Set the background color of this element */
    // console.log("convertToHex", this.convertToHex(c));
    // start = c;
    // }
    return "#" + this.convertToHex(c);
  };

  obtieneTotales = (data) => {
    var EmbarquesMaritimos = 0;
    var EmbarquesAereos = 0;
    var Contenedores = 0;
    var EmbarquesTerrestres = 0;

    var CO2Maritimos = 0;
    var CO2Aereos = 0;
    var CO2Terrestres = 0;

    if (data.totales) {
      data.totales.forEach((tot) => {
        if (Number(tot.Tipo) === 1) {
          EmbarquesMaritimos = tot.Total;
          CO2Maritimos = tot.TotalCO2;
        } else if (Number(tot.Tipo) === 2) {
          EmbarquesAereos = tot.Total;
          CO2Aereos = tot.TotalCO2;
        } else if (Number(tot.Tipo) === 3) {
          EmbarquesTerrestres = tot.Total;
          CO2Terrestres = tot.TotalCO2;
        } else if (Number(tot.Tipo) === 4) {
          Contenedores = tot.Total;
        }
      });
    }

    var totales = {};

    totales = {
      EmbarquesMaritimos,
      EmbarquesAereos,
      Contenedores,
      EmbarquesTerrestres,
      CO2Maritimos,
      CO2Aereos,
      CO2Terrestres,
    };
    return totales;
  };

  /*=============================================
  =            Life Cicle Component             =
  =============================================*/

  componentDidUpdate = (nextProps) => {
    // console.log("nextProps", nextProps);
    // if (this.props.lang != nextProps.lang) {
    //   i18n.changeLanguage(nextProps.lang)
    // }
  };
  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMovil: isMobileDevice,
    });

    this.getInfoDashBoard();
    document.getElementById("body").className = "layout-fixed"; // !changed for nothing
  };

  ChartModoTransporte = () => {
    let { isMovil, colors, eventosAtencion } = this.state;
    let dataChart = eventosAtencion ? eventosAtencion : [];

    return (
      <div className="col-xs-12 col-md-6 .col-lg-6 ">
        <div className="card myCard equalsWidth">
          <div className="card-header">
            <div className="card-title">{this.props.t("events_attention")}</div>
          </div>
          <div className="card-body" style={{ overflow: "hidden" }}>
            {isMovil ? (
              <div className="d-flex justify-content-center align-items-center">
                {dataChart.map((e, i) => {
                  return (
                    <>
                      <i
                        className="fas fa-circle m-1"
                        style={{ color: colors[i] }}
                      ></i>
                      <span className="label-graphic">{e.label}</span>
                    </>
                  );
                })}
              </div>
            ) : (
              <div></div>
            )}

            <EventsTable data={dataChart} />
          </div>
        </div>
      </div>
    );
  };

  // onChangeYear = async (year) => {
  //   let { tendenciaData, maxTendencia } = this.state;
  //   maxTendencia = 0;
  //   let data = {
  //     Entities: this.props.clients ? JSON.stringify(this.props.clients) : '[0]',
  //     year: year.value
  //   };
  //   try {
  //     //############ INVOCACION COMENTADA ##############
  //     let response = await Axios.post(
  //       `${Services.DASHBOARD.path}dashboard/tembarques`,
  //       data
  //     );
  //     if (response.status === 200) {
  //       tendenciaData = [[
  //         "x",
  //         "Embarques"
  //       ]];

  //       response.data.data[0].data.map((mes) => {
  //         tendenciaData.push([mes[0], parseInt(mes[1])]);
  //         if (parseInt(mes[1]) > maxTendencia) {
  //           maxTendencia = parseInt(mes[1]);
  //         }
  //       });
  //     }
  //     this.setState({ tendenciaData, maxTendencia });

  //     // let TrendShipmentByYear = dummyInfo.tEmbarques[year.value]
  //     //this.setState({ tendenciaData: TrendShipmentByYear });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      estatusEmbarques,
      totales,
      tendenciaData,
      loadingTrends,
      loadingTrendYear,
      loadingTotals,
      fullLoader,
      titleShipmentForCountry,
      optionShipmentForCountry,
      optionShipmentDefault,
      optionShipmentTrendYear,
      optionShipmentTrendDefafault,
      MapShipmentCountry,
      loadingShiptmenMap,
    } = this.state;
    const { classes } = this.props;

    return (
      <>
        <>
          <Loader hidden={fullLoader} />
          <ContentWrapper>
            <div className="content-heading">
              <legend className="legendBasic">
                {/* <img
                  style={{ margin: "-6px 6px 1px" }}
                  alt=""
                  src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_tablero-de-control.svg"
                  height="28"
                  width="28"
                ></img> */}

                <i className="icon-10abr23-iconosmagicdome-01_"></i>
                {this.props.t("dashboard")}
              </legend>
            </div>
            <Row>
              <CardsTotals
                image={
                  <img
                    src="https://magiclog.blob.core.windows.net/onboardpic/sea_shipment_white.png"
                    alt=""
                    style={{
                      width: "3.5em",
                      height: "3.5em",
                    }}
                  />
                }
                xl={3}
                md={6}
                sm={6}
                loading={loadingTotals}
                total={totales.EmbarquesMaritimos}
                title={this.props.t("sea_shipments")}
                accentColor={"#0060a8"}
                co2={totales.CO2Maritimos} // TODO: reemplazar cuando el API entregue el valor real de CO2
              />
              <CardsTotals
                image={
                  <img
                    src="https://magiclog.blob.core.windows.net/onboardpic/air_shipment_white.png"
                    alt=""
                    style={{
                      width: "3.5em",
                      height: "3.5em",
                    }}
                  />
                }
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totales.EmbarquesAereos}
                title={this.props.t("air_shipments")}
                accentColor={"#535353"}
                co2={totales.CO2Aereos} // TODO: reemplazar cuando el API entregue el valor real de CO2
              />
              <CardsTotals
                image={
                  <img
                    src="https://magiclog.blob.core.windows.net/onboardpic/road_shipment_white.png"
                    alt=""
                    style={{
                      width: "3.5em",
                      height: "3.5em",
                    }}
                  />
                }
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totales.EmbarquesTerrestres}
                title={this.props.t("road_shipments")}
                accentColor={"#66969e"}
                co2={totales.CO2Terrestres} // TODO: reemplazar cuando el API entregue el valor real de CO2
              />
              <CardsTotals
                image={
                  <img
                    src="https://magiclog.blob.core.windows.net/onboardpic/dashboardOther.png"
                    alt=""
                    style={{
                      width: "3.5em",
                      height: "3.5em",
                    }}
                  />
                }
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totales.Contenedores}
                title={this.props.t("other_services")}
                accentColor={"#25b9ec"}
                showCo2={false}
              />
            </Row>
            <Row style={{ marginTop: "30px" }}>
              <div className="col-xs-12 col-md-6 .col-lg-6 ">
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title">
                      {this.props.t("shipments_perlast")}
                    </div>
                  </div>
                  <div className="card-body" style={{ overflow: "hidden" }}>
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Chart
                          style={{
                            width: "100%",
                            //  marginTop: "-25px"
                          }}
                          className={"tag-custom-value"}
                          chartType="BarChart"
                          loader={<div>Loading Chart</div>}
                          data={estatusEmbarques}
                          options={{
                            width: "100%",
                            height: "300px",

                            chartArea: {
                              height: "70%",
                              // width: "80%",
                              width: "100%",
                              left: "12%",
                            },
                            tooltip: { isHtml: true },
                            legend: {
                              position: "none",
                            },
                            animation: {
                              startup: true,
                              easing: "linear",
                              duration: 1000,
                            },
                            hAxis: {
                              textStyle: {
                                color: "#535353",
                                fontSize: 11,
                              },
                            },
                            vAxis: {
                              textStyle: {
                                color: "#535353",
                                fontSize: 11,
                              },
                            },
                          }}
                          rootProps={{ "data-testid": "6" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 .col-lg-6 ">
                <div className="card myCard equalsWidth">
                  <div className="card-header ">
                    <div className="card-title ">
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        className="row"
                      >
                        <div className="col-xs-12 col-md-9 col-lg-9">
                          {this.props.t("shipment_tendency")}
                        </div>
                        <div className="col-xs-12 col-md-3 col-lg-3">
                          <Autocomplete
                            closeText={false}
                            openText={false}
                            disableClearable={true}
                            style={{ marginTop: "6px" }}
                            id="size-small-standard"
                            className="input-basic"
                            size="small"
                            ListboxProps={{
                              sx: {
                                fontSize: 12,
                                color: "#000",
                              },
                            }}
                            sx={{
                              "& .MuiAutocomplete-input, & .MuiInputLabel-root":
                                {
                                  fontSize: 12,
                                  color: "#000",
                                },
                            }}
                            options={optionShipmentTrendYear}
                            defaultValue={optionShipmentTrendDefafault}
                            onChange={this.handleChangeDrop("shipmentTrend")}
                            renderInput={(params) => {
                              return (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  className={classes.textfield}
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body" style={{ overflow: "hidden" }}>
                    {loadingTrendYear ? (
                      <FullLoader />
                    ) : (
                      <div id="chartDashboard">
                        <Chart
                          chartType="ScatterChart"
                          data={tendenciaData}
                          // style={{
                          //   width: "100%",
                          // }}
                          width="100%"
                          height="300px"
                          className={"tag-custom-value"}
                          // chartType="AreaChart"
                          loader={<div>Loading Chart</div>}
                          options={{
                            chartArea: {
                              height: "70%",
                              // width: "80%",
                              width: "100%",
                              left: "12%",
                            },
                            // width: "100%",
                            // height: "300px",
                            curveType: "function",
                            legend: {
                              position: "none",
                            },
                            tooltip: { isHtml: true },
                            // vAxis: {
                            //   minValue: 0,
                            //   viewWindow: { min: 0, max: maxTendencia + 1, textStyle: { color: "#535353", fontSize: 11 } },
                            // },
                            vAxis: {
                              viewWindow: { min: 0 },
                              // format: "currency",
                              textStyle: { color: "#535353", fontSize: 11 },
                            },
                            hAxis: {
                              textStyle: { color: "#535353", fontSize: 11 },
                            },

                            pointColor: "red",
                            pointSize: 5,
                            series: {
                              0: {
                                color: "#0060a8",
                                lineWidth: 2,
                              },
                            },
                          }}
                          rootProps={{ "data-testid": "1" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {this.ChartModoTransporte()}
              <div className="col-xs-12 col-md-6 .col-lg-6 ">
                <Card className="myCard equalsWidth">
                  <div className="card-header ">
                    <div className="card-title ">
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        className="row"
                      >
                        <div className="col-xs-12 col-md-9 col-lg-9">
                          {" "}
                          {titleShipmentForCountry}{" "}
                        </div>
                        <div className="col-xs-12 col-md-3 col-lg-3">
                          <Autocomplete
                            closeText={false}
                            openText={false}
                            disableClearable={true}
                            style={{ marginTop: "6px" }}
                            id="size-small-standard"
                            className="input-basic"
                            size="small"
                            ListboxProps={{
                              sx: {
                                fontSize: 12,
                                color: "#000",
                              },
                            }}
                            sx={{
                              "& .MuiAutocomplete-input, & .MuiInputLabel-root":
                                {
                                  fontSize: 12,
                                  color: "#000",
                                },
                            }}
                            options={optionShipmentForCountry}
                            defaultValue={optionShipmentDefault}
                            onChange={this.handleChangeDrop(
                              "shipmentForCountry",
                            )}
                            renderInput={(params) => {
                              return (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  className={classes.textfield}
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <CardBody style={{ overflow: "hidden" }}>
                    {loadingShiptmenMap ? (
                      <ShipmentMap />
                    ) : (
                      // this.state.map
                      MapShipmentCountry
                    )}
                  </CardBody>
                </Card>
              </div>
            </Row>
          </ContentWrapper>
        </>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
  lang: state.header.lang,
});
const mapDispatchToProps = () => ({});

export default withNamespaces()(
  withStyles(useStyles)(connect(mapStateToProps, mapDispatchToProps)(Home)),
);
